import React from 'react'

const VideoAudioPlayer = ({ videoAudioURL, handleCloseVideoAudio }) => {
    return (
        <>
            <div
                className='position-fixed d-flex align-items-center justify-content-center'
                style={{
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.7)", 
                    zIndex: 1000,
                    transition: "background-color 0.3s ease", 
                }}
                onClick={handleCloseVideoAudio}
            >
                <button
                    onClick={handleCloseVideoAudio}
                    className='cursor-pointer text-white position-absolute font-w600'
                    style={{
                        top: "20px",
                        right: "20px",
                        background: "transparent",
                        border: "none",
                        fontSize: "40px",
                        color: "white",
                        opacity: 0.6,
                        transition: "opacity 0.3s", 
                    }}
                    onMouseEnter={(e) => e.target.style.opacity = 1} 
                    onMouseLeave={(e) => e.target.style.opacity = 0.8} 
                >
                    &times;
                </button>

                <div
                    className='position-relative overflow-hidden d-flex align-items-center justify-content-center'
                    style={{
                        width: "90%", 
                        maxWidth: "1000px", 
                        height: "80vh",
                        margin: "0 auto", 
                    }}
                    onClick={(e) => e.stopPropagation()} 
                >
                    <div
                        style={{
                            overflow: 'hidden',
                            width: '100%',
                            height: '100%',
                            borderRadius: "12px",
                            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.3)", 
                            // backgroundColor: "white", 
                        }}
                    >
                        <video
                            controls
                            src={videoAudioURL}
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: "12px", 
                                objectFit: 'contain', 
                            }}
                            autoPlay
                            // loop
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default VideoAudioPlayer